/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Hero_TitleInputs */

const en_mcp_hero_title = /** @type {(inputs: Mcp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your AI chats into audio`)
};

const es_mcp_hero_title = /** @type {(inputs: Mcp_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte tus chats de IA en audio`)
};

/**
* | output |
* | --- |
* | "Turn your AI chats into audio" |
*
* @param {Mcp_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_hero_title = /** @type {((inputs?: Mcp_Hero_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Hero_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_hero_title(inputs)
	return en_mcp_hero_title(inputs)
});